import React, { useState } from "react";

import TemplateCard from "./TemplateCard";
import { DefaultTabs } from "./tabs/default";
import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";

export default function DefaultCard({ setProjectsVisible }) {
  const tabOptions = {
    Home: DefaultTabs.Home(),
    Projects: DefaultTabs.Projects(setProjectsVisible, undefined),
    Publications: DefaultTabs.Publications(),
    Contact: DefaultTabs.Contact(),
  };
  const startingTab = "Home";
  return (
    <div className="flex flex-col gap-4 h-full sm:h-auto items-center">
      <div className="inline-flex gap-4 items-center w-full bg-green-500 bg-opacity-30 p-2 border-2 border-green-800  text-green-200  font-semibold rounded-lg transparent whitespace-break-spaces max-w-full">
        <QuestionMarkCircleIcon class="hidden sm:block w-5 h-5" />
        <p>
          Are you a recruiter? My resume links to the full portfolio version of
          this site.
        </p>
      </div>
      <TemplateCard tabOptions={tabOptions} startingTab={startingTab} />;
    </div>
  );
}
